export var source_static_route = { "uid": "source_static_route", "fields": { "title": { "defaultValue": "" }, "route_url": { "defaultValue": "" } } };
